<template>
  <div ref="popup" v-show="isVisible" :style="popupStyle" class="selection-popup absolute rounded-borders my-bg2 my-text1 row no-wrap items-center">
    <t-btn v-if="isDev" flat size="sm" label="save pill" @click="savePill" />
    <speak-btn :text="text" />
    <base-gemini-btn label="learn more" @click="$stores.modals.aiTutorModal = {expression: text}"/>
  </div>
</template>

<script>
import SpeakBtn from '../tools/tts/SpeakBtn.vue'
import BaseGeminiBtn from './BaseGeminiBtn.vue'
export default {
  data() {
    return {
      isVisible: false,
      popupStyle: {
        top: '0px',
        left: '0px',
      },
      selectionRange: null, // Store selection range for tracking
    }
  },
  components: { SpeakBtn, BaseGeminiBtn },
  computed: {
    text() {
      return this.selectionRange?.toString().trim()
    },
    isDev() {
      return this.$stores.user.userAccess?.dev
    },
  },
  methods: {
    handleSelection() {
      setTimeout(() => {
        const selection = window.getSelection()
        if (!selection || selection.toString().trim() === '') {
          this.isVisible = false
          return
        }

        this.selectionRange = selection.getRangeAt(0) // Store selection for tracking
        this.updatePopupPosition()
        this.isVisible = true
      }, 10)
    },
    updatePopupPosition() {
      if (!this.selectionRange) return

      const rect = this.selectionRange.getBoundingClientRect()

      this.popupStyle = {
        top: `${window.scrollY + rect.top - 50}px`,
        left: `${window.scrollX + rect.left}px`,
      }
    },
    // Dev only: "word - definition" or "word: definition" fills both pill fields
    savePill() {
      if (!this.text) return
      const match = this.text.match(/^(.+?)\s*[-–—:]\s*(.+)$/)
      const suggestedFields = match ? { a: match[1].trim(), b: match[2].trim() } : { a: this.text, b: '' }
      this.$stores.modals.devPillEditModal = { suggestedFields }
      this.isVisible = false
    },
    handleClickOutside(event) {
      if (this.$refs.popup && !this.$refs.popup.contains(event.target)) {
        this.isVisible = false
      }
    },
    handleScrollOrResize() {
      if (this.isVisible) {
        this.updatePopupPosition() // Recalculate position on scroll/resize
      }
    },
  },
  mounted() {
    document.addEventListener('mouseup', this.handleSelection)
    document.addEventListener('click', this.handleClickOutside)
    window.addEventListener('scroll', this.handleScrollOrResize)
    window.addEventListener('resize', this.handleScrollOrResize)
  },
  beforeUnmount() {
    document.removeEventListener('mouseup', this.handleSelection)
    document.removeEventListener('click', this.handleClickOutside)
    window.removeEventListener('scroll', this.handleScrollOrResize)
    window.removeEventListener('resize', this.handleScrollOrResize)
  },
}
</script>

<style scoped>
.selection-popup {
  padding: 6px 12px;
  gap: 8px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}
</style>
